module.exports = __webpack_public_path__ + "static/media/flutter.7e569a40.png";